import { API_ORIGIN } from "@/api/apiFetch";
import { useListEnrollmentAttachments } from "@/api/generated/enrollments/enrollments";
import type { CourseAttachment } from "@/api/generated/model";

interface EnrollmentAttachments {
  attachments: CourseAttachment[];
  isLoading: boolean;
  error: Error | undefined;
}

/**
 * Loads the documents of an enrollment's course for the header menu. The
 * backend sends each download URL as a path on its own origin and the SPA may
 * live elsewhere, so the URLs are resolved against the backend origin here.
 * Lazy: nothing is fetched until `enabled`, so the menu only asks once opened.
 */
const useEnrollmentAttachments = (
  enrollmentId: string,
  enabled: boolean
): EnrollmentAttachments => {
  const { data, error, isLoading } = useListEnrollmentAttachments<Error>(
    enrollmentId,
    { swr: { enabled } }
  );

  const attachments = (data?.attachments ?? []).map((attachment) => ({
    ...attachment,
    url: new URL(attachment.url, API_ORIGIN).toString(),
  }));

  return { attachments, isLoading, error };
};

export { useEnrollmentAttachments };
